export const SYSTEM_PERMISSIONS = {
  // Módulo de Usuarios
  USER_CREATE: 'user:create',
  USER_UPDATE: 'user:update',
  USER_DELETE: 'user:delete',
  USER_READ: 'user:read',

  // Módulo de Productos (Ecommerce)
  PRODUCT_CREATE: 'product:create',
  PRODUCT_UPDATE: 'product:update',
  PRODUCT_DELETE: 'product:delete',
  PRODUCT_READ: 'product:read',

  // Módulo de ofertas
  OFFER_CREATE: 'offer:create',
  OFFER_UPDATE: 'offer:update',
  OFFER_DELETE: 'offer:delete',
  OFFER_READ: 'offer:read',

  // Módulo de Órdenes / Ventas
  ORDER_CREATE: 'order:create',
  ORDER_UPDATE: 'order:update',
  ORDER_DELETE: 'order:delete',
  ORDER_READ: 'order:read',

  // Módulo de Sucursales (Locations)
  LOCATION_CREATE: 'location:create',
  LOCATION_UPDATE: 'location:update',
  LOCATION_DELETE: 'location:delete',
  LOCATION_READ: 'location:read',

  // Configuración del Partner (SaaS)
  PARTNER_CONFIG_MANAGE: 'partner_profile:update',
  PARTNER_CONFIG_READ: 'partner_profile:read',

  // Reportes y Analítica
  REPORTS_READ: 'reports:read',
  REPORTS_EXPORT: 'reports:export',

  CUSTOMER_CREATE: 'customer:create',
  CUSTOMER_UPDATE: 'customer:update',
  CUSTOMER_DELETE: 'customer:delete',
  CUSTOMER_READ: 'customer:read',

  // Módulo de categorias e inventario
  CATEGORY_CREATE: 'category:create',
  CATEGORY_UPDATE: 'category:update',
  CATEGORY_DELETE: 'category:delete',
  CATEGORY_READ: 'category:read',

  // Módulo de personalización y modificadores
  MODIFIER_CREATE: 'modifier:create',
  MODIFIER_UPDATE: 'modifier:update',
  MODIFIER_DELETE: 'modifier:delete',
  MODIFIER_READ: 'modifier:read',

  STOCK_UPDATE: 'stock:update',
  STOCK_READ: 'stock:read',

  PAYMENT_CREATE: 'payment:create',
  PAYMENT_UPDATE: 'payment:update',
  PAYMENT_DELETE: 'payment:delete',
  PAYMENT_READ: 'payment:read',

  /**TASAS DE CAMBIO y METODOS DE PAGO */
  FINANCE_CREATE: 'finance:create',
  FINANCE_UPDATE: 'finance:update',
  FINANCE_DELETE: 'finance:delete',
  FINANCE_READ: 'finance:read',

  ROLE_CREATE: 'role:create',
  ROLE_UPDATE: 'role:update',
  ROLE_DELETE: 'role:delete',
  ROLE_READ: 'role:read',

  METRICS_READ: 'metrics:read',
  METRICS_EXPORT: 'metrics:export',
} as const;

export const ALL_SYSTEM_PERMISSIONS = Object.values(SYSTEM_PERMISSIONS);

export type TSYSTEM_PERMISSIONS = (typeof ALL_SYSTEM_PERMISSIONS)[number];
